const BREAKPOINTS = {
  SMALL: '@media (min-width: 320px)',
  MEDIUM: '@media (min-width: 768px)',
  LARGE: '@media (min-width: 1280px)',
};

export default BREAKPOINTS;
